export const NOTIFICATION_REFRESH_EVENT = "trazia:notification-refresh";
export const CRM_DATA_REFRESH_EVENT = "trazia:crm-data-refresh";

const EMPTY_PENDING = { today: [], overdue: [], urgent: [], todayCount: 0, overdueCount: 0 };

/** Normaliza la respuesta de /crm/pending: los contadores siempre salen de los arreglos. */
export function normalizePending(raw) {
  const today = Array.isArray(raw?.today) ? raw.today : [];
  const overdue = Array.isArray(raw?.overdue) ? raw.overdue : [];
  const urgent = Array.isArray(raw?.urgent) ? raw.urgent : [];
  return {
    today,
    overdue,
    urgent,
    todayCount: today.length,
    overdueCount: overdue.length,
  };
}

export function emptyPending() {
  return { ...EMPTY_PENDING };
}

/** Dispara actualización de la campana y otros consumidores de pending. */
export function requestNotificationRefresh() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(NOTIFICATION_REFRESH_EVENT));
  }
}

/** Recarga cartera, KPIs y tablero después de un movimiento del día. */
export function requestCrmDataRefresh() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CRM_DATA_REFRESH_EVENT));
  }
}

/** IDs de leads con seguimiento pendiente (hoy o vencido) según el backend. */
export function pendingLeadIds(pending) {
  const ids = new Set();
  for (const lead of pending?.overdue || []) {
    if (lead?._id) ids.add(String(lead._id));
  }
  for (const lead of pending?.today || []) {
    if (lead?._id) ids.add(String(lead._id));
  }
  return ids;
}
